/**
 * Secure auth storage utility.
 * Uses sessionStorage (cleared on tab close) instead of localStorage
 * to reduce XSS attack surface for auth data.
 */

const STORAGE = typeof window !== 'undefined' ? window.sessionStorage : null;

export const authStorage = {
  // Author auth
  setAuthorAuth(user) {
    if (!STORAGE) return;
    STORAGE.setItem('author_authenticated', 'true');
    STORAGE.setItem('author_user', JSON.stringify(user));
  },
  getAuthorUser() {
    if (!STORAGE) return null;
    try {
      const data = STORAGE.getItem('author_user');
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  },
  isAuthorAuthenticated() {
    return STORAGE?.getItem('author_authenticated') === 'true';
  },
  clearAuthorAuth() {
    if (!STORAGE) return;
    STORAGE.removeItem('author_authenticated');
    STORAGE.removeItem('author_user');
  },
  updateAuthorUser(user) {
    if (!STORAGE) return;
    STORAGE.setItem('author_user', JSON.stringify(user));
  },

  // Admin auth
  setAdminAuth(email) {
    if (!STORAGE) return;
    STORAGE.setItem('admin_authenticated', 'true');
    STORAGE.setItem('admin_email', email);
  },
  isAdminAuthenticated() {
    return STORAGE?.getItem('admin_authenticated') === 'true';
  },
  getAdminEmail() {
    return STORAGE?.getItem('admin_email') || null;
  },
  clearAdminAuth() {
    if (!STORAGE) return;
    STORAGE.removeItem('admin_authenticated');
    STORAGE.removeItem('admin_email');
  },
};
